import { styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { borderRadius, iconButtonSize } from "@iventis/styles/src/atomic-rules";
import { sharedNodeCss, StyledLibraryNodeProps } from "@iventis/tree-browser/implementations/library/styles/library-shared-node.styles";
import { GALLERY_NODE_CONTENT_CLASS_NAME } from "./library-tile-view";

export const StyledLibraryTileNode = styled.div<StyledLibraryNodeProps>`
    display: grid;
    grid-template-rows: ${iconButtonSize} 1fr;
    min-height: 265px;
    width: 230px;
    box-sizing: border-box;
    border-radius: ${borderRadius.standard};
    border: 1px solid ${(props: { theme: Theme }) => props.theme.shades.lightBorder};
    // Padding to accomodate smaller border when not hovering
    padding: 1px;
    box-shadow: 0 7px 10px -5px rgba(81, 82, 101, 0.26);

    h6 {
        text-decoration: none;
    }

    ${sharedNodeCss};

    ${({ draggingNode }) => {
        if (draggingNode) {
            return `:hover, &[aria-selected="true"] {
        border: 2px solid ${(props: { theme: Theme }) => props.theme.tertiaryColors.primary};
        padding: 0;
    }`;
        }
        return "";
    }}

    .gallery-card-top-row {
        display: grid;
        min-width: 0;
        grid-template-columns: ${({
            theme: {
                sizes: { iconButtonWidth },
            },
        }: {
            theme: Theme;
        }) => `${iconButtonWidth} 1fr ${iconButtonWidth} ${iconButtonWidth}`};

        .gallery-ellipsis {
            height: 100%;
            position: relative;
            grid-column-start: 4;
        }
        .favourite {
            grid-column-start: ${({ singleTopRowButton }) => (singleTopRowButton ? 4 : 3)};
            height: 100%;
        }
    }

    .gallery-card-main {
        display: flex;
        flex-direction: column;
        position: relative;
        min-width: 0;
        .gallery-thumbnail {
            height: 101px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            color: ${(props: { theme: Theme }) => props.theme.tertiaryColors.primary};
        }
        .content {
            display: flex;
            flex-direction: column;
            padding: 15px;
            /* In order for the interactive element (positioned absolutely) to wholly cover the content. This one is wrapped in the tooltip container for long names */
            position: relative;

            .${GALLERY_NODE_CONTENT_CLASS_NAME} {
                flex-direction: column;
                justify-content: start;
                align-items: start;
            }
        }
        .breadcrumbs-container {
            position: relative;
            /* High enough for two lines of text plus a little on the bottom to make it look nice */
            height: 35px;
        }
        :hover:not(:has(.bottom-up-breadcrumb:hover)) {
            h6 {
                text-decoration: underline;
            }
        }
    }
`;
